import { Colors } from 'modules/theme';

/** List header button height (same as search/filters) */
export const LIST_HEADER_BUTTON_HEIGHT = 44;

/** Styles for the primary "New" button in list headers */
export const listHeaderPrimaryButtonStyles = {
  width: 'auto',
  height: `${LIST_HEADER_BUTTON_HEIGHT}px`,
  minHeight: `${LIST_HEADER_BUTTON_HEIGHT}px`,
  padding: '0 16px',
  fontSize: '14px',
  lineHeight: '20px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '6px',
  boxSizing: 'border-box',
};

/** Styles for the secondary header button (e.g. "Import Approval") */
export const listHeaderSecondaryButtonStyles = {
  ...listHeaderPrimaryButtonStyles,
  backgroundColor: Colors.white,
  border: `1px solid ${Colors.lightBlue}`,
  color: Colors.lightBlue,
};
